module.exports = __webpack_public_path__ + "img/product_63.43e71ef.webp";